import BlPickerListMv from './BlPickerListMv.vue'

BlPickerListMv.install = function(Vue) {
  Vue.component(BlPickerListMv.name, BlPickerListMv)
}

export default BlPickerListMv
